import { JsonType } from 'posthog-js';
import { useFeatureFlagEnabled, useFeatureFlagPayload } from 'posthog-js/react';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { initializeFeatureFlags } from '../actions/featureFlagsActions';
import env from '../env';
import { FEATURE_FLAG_NAMES } from '../types/hubEnums';
import { posthog } from '../util/posthog';

export const useFeatureFlag = (flag: string): boolean => {
  return useFeatureFlagEnabled(flag);
};

export const useGetFeatureFlagPayload = (flag: string): JsonType => {
  return useFeatureFlagPayload(flag);
};

export const useFeatureFlagInitialization = (callback?: (flags: Record<string, boolean>) => void) => {
  const dispatch = useDispatch();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!env.REACT_APP_POSTHOG_ENABLED || hasInitialized.current) {
      return;
    }

    const handleFeatureFlags = () => {
      if (hasInitialized.current) return;

      console.log('[debug] PostHog feature flags loaded');

      const flags: Record<string, boolean> = {};
      const payloads: Record<string, any> = {};

      const featureFlagNames = Object.values(FEATURE_FLAG_NAMES) as string[];

      featureFlagNames.forEach((flagName) => {
        const isEnabled = posthog.isFeatureEnabled(flagName);
        flags[flagName] = isEnabled;

        if (isEnabled) {
          const payload = posthog.getFeatureFlagPayload(flagName);
          if (payload !== undefined) {
            payloads[flagName] = payload;
          }
        }
      });

      hasInitialized.current = true;
      dispatch(initializeFeatureFlags(flags, payloads));
      if (callback) {
        callback(flags);
      }
    };

    posthog.onFeatureFlags(handleFeatureFlags);
    return () => {};
  }, [dispatch, callback]);
};
